enum ViewLevel {
  LineItem = 'Line Item',
}

export default ViewLevel;
